import { useState, useEffect, useRef } from 'react';
import ModelListing from './models/modelListing';
import ModelSummary from './widgets/modelSummary';
import './dashboard.css';
import DashboardIcon from '../../assets/material-symbols_dashboard.svg';
import PageHeader from 'components/Header/Page';
import PageWrapper from 'components/Common/PageWraper';

const MLOBSDashboard = () => {
	const dataFetchedRef = useRef(false);
	const [sharedValue, setSharedValue] = useState('');
	const updateSharedValue = (newValue: any) => {
		setSharedValue(newValue);
	};
	useEffect(() => {
		if (dataFetchedRef.current) return;
		dataFetchedRef.current = true;
	});
	return (
		<PageWrapper>
			<PageHeader title="Summary" icon={DashboardIcon} />
			<ModelSummary sharedValue={sharedValue} updateSharedValue={updateSharedValue}></ModelSummary>
			<ModelListing sharedValue={sharedValue} />
		</PageWrapper>
	);
};

export default MLOBSDashboard;
